import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import sx, { SxProp } from '../../internal/styles/sx';
import CloseIcon from '../CloseIcon';

export interface ModalCloseIconProps extends SxProp {
  onClose?: () => void;
  'aria-label'?: string;
}

export const StyledModalCloseIcon = styled.div<SxProp>(
  css({
    position: 'absolute',
    left: '12px',
    top: '20px',
    zIndex: 'modal',
  }),
  sx
);

export const ModalCloseIcon: FC<ModalCloseIconProps> = ({
  onClose,
  'aria-label': ariaLabel,
  sx,
}) => {
  return (
    <StyledModalCloseIcon sx={sx}>
      <CloseIcon
        size="medium"
        color="primary.50"
        hoverColor="primary.70"
        onClick={onClose}
        aria-label={ariaLabel}
      />
    </StyledModalCloseIcon>
  );
};
